export enum roles {
    ADMIN = "Admin",
    PREST = "Prest",
    PROST = "Prost",
    BEREDSKAPSANSVARLIG = "Beredskapsansvarlig",
    SECURITAS = "Securitas",
    UNKNOW = "Unknown",
}
